<template>
  <a-modal
    :wrapClassName="disabled ? 'ps-see-form-modal' : ''"
    :title="title"
    width="40%"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :maskClosable="false"
    :keyboard="false"
    @cancel="handleCancel"
    @ok="submit"
    ok-text="确认"
    cancel-text="取消"
    :destroyOnClose="true"
  >
    <div>
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="教师姓名" prop="teacherName">
          <a-input v-model="form.teacherName" :disabled="disabled" />
        </a-form-model-item>
        <a-form-model-item label="性别" prop="sex">
          <a-select v-model="form.sex" :disabled="disabled">
            <a-select-option :value="1">男</a-select-option>
                        <a-select-option :value="2">女</a-select-option>
            <!--<a-select-option :value="item.value" v-for="item in sexlist">{{item.title}}</a-select-option>-->
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="出生日期" prop="birthday">
          <a-date-picker
            v-model="form.birthday"
            :disabled="disabled"
            :locale="locale"
          />
        </a-form-model-item>
        <a-form-model-item label="学历">
          <a-select v-model="form.degree" :disabled="disabled">
            <a-select-option :value="item.value" v-for="item in xwlist">{{
              item.title
            }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="职称" prop="professionalTitle">
          <!--<a-input v-model="form.professionalTitle" />-->
          <a-select v-model="form.professionalTitle" :disabled="disabled">
            <a-select-option :value="item.value" v-for="item in zclist">{{
              item.title
            }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="从事专业">
          <a-input v-model="form.major" :disabled="disabled" />
        </a-form-model-item>
        <a-form-model-item label="主要任务">
          <a-textarea
            v-model="form.primaryMission"
            placeholder="请输入主要任务"
            :disabled="disabled"
            :auto-size="{ minRows: 4, maxRows: 6 }"
          />
        </a-form-model-item>
        <a-form-model-item label="是否思政老师" prop="izPolitical">
          <a-select v-model="form.izPolitical" :disabled="disabled">
            <a-select-option value="1">是</a-select-option>
                        <a-select-option value="0">否</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="是否负责人" prop="izResponse">
          <a-select v-model="form.izResponse" :disabled="disabled">
            <a-select-option :value="1">是</a-select-option>
                        <a-select-option :value="0">否</a-select-option>
            <!--<a-select-option :value="item.value" v-for="item in sjlist">{{item.title}}</a-select-option>-->
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="加入年份" prop="joinYear">
          <a-date-picker
            :disabled="disabled"
            placeholder="请选择加入年份"
            v-model="form.joinYear"
            :open="yearShowOne"
            :locale="locale"
            :format="'YYYY'"
            mode="year"
            @openChange="openChangeOne"
            @panelChange="panelChangeOne"
            @clear="handleClearAcquireYear"
          />
        </a-form-model-item>
        <a-form-model-item label="成员来源" prop="memberSource">
          <a-select v-model="form.memberSource" :disabled="disabled">
            <a-select-option :value="item.value" v-for="item in cylist">{{
              item.title
            }}</a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </div>
  </a-modal>
</template>
  
<script>
import { getAction, postAction, putAction } from "@/api/index";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
moment.locale("zh-cn");
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      other: "",
      form: {
        applyId: "",
        teacherName: "",
        sex: "",
        birthday: "",
        degree: "",
        professionalTitle: "",
        major: "",
        primaryMission: "",
        izPolitical: "",
        joinYear: "",
        izResponse: "0",
        memberSource: "",
      },
      rules: {
        teacherName: [
          {
            required: true,
            message: "请输入教师姓名",
            trigger: "blur",
          },
        ],
        sex: [
          {
            required: true,
            message: "请选择教师性别",
            trigger: "change",
          },
        ],
        birthday: [
          {
            required: true,
            message: "请选择教师生日",
            trigger: "change",
          },
        ],
        //      degree:[
        //        {
        //          required: true,
        //          message: "请输入教师学历",
        //          trigger: "change",
        //        },
        //      ],
        professionalTitle: [
          {
            required: true,
            message: "请输入教师职称",
            trigger: "blur",
          },
        ],
        //      major:[
        //         {
        //          required: true,
        //          message: "请输入从事专业",
        //          trigger: "blur",
        //        },
        //      ],
        //      primaryMission:[
        //         {
        //          required: true,
        //          message: "请输入主要任务",
        //          trigger: "blur",
        //        },
        //      ],
        izPolitical: [
          {
            required: true,
            message: "请选择是否是思政老师",
            trigger: "change",
          },
        ],
        izResponse: [
          {
            required: true,
            message: "请选择是否是负责人",
            trigger: "change",
          },
        ],
        joinYear: [
          {
            required: true,
            message: "请选择加入年份",
            trigger: "blur",
          },
        ],
        memberSource: [
          {
            required: true,
            message: "请选择成员来源",
            trigger: "change",
          },
        ],
      },
      sexlist: [],
      sjlist: [],
      zclist: [],
      cylist: [],
      zh_CN,
      locale,
      yearShowOne: false,
      applyType: 3,
      // 添加还是编辑
      type: "",
      // 弹框标题
      title: "",
      xwlist: [],
      disabled: false,
    };
  },
  methods: {
    init(type, record) {
      this.type = type;
      this.visible = true;
      this.disabled = false;
      //    this.getsexlist();
      //    this.getsjlist();
      this.getxwlist();
      this.getzclist();
      this.getcylist();
      if (type == "add") {
        this.form = {};
        this.form.applyId = record.id;
        console.log(record);
        this.title = "添加老师";
      } else if (type == "edit") {
        this.title = "编辑老师";
        this.form = {
          teacherName: record.teacherName,
          sex: record.sex,
          birthday: record.birthday,
          degree: record.degree,
          professionalTitle: record.professionalTitle,
          major: record.major,
          primaryMission: record.primaryMission,
          izResponse: record.izResponse,
          applyId: record.applyId,
          id: record.id,
          izPolitical: record.izPolitical,
          joinYear: record.joinYear,
          memberSource: record.memberSource,
        };
      } else {
        this.disabled = true;
        this.title = "查看老师";
        this.saveText = "关闭";
        this.form = {
          teacherName: record.teacherName,
          sex: record.sex,
          birthday: record.birthday,
          degree: record.degree,
          professionalTitle: record.professionalTitle,
          major: record.major,
          primaryMission: record.primaryMission,
          izResponse: record.izResponse,
          applyId: record.applyId,
          id: record.id,
          izPolitical: record.izPolitical,
          joinYear: record.joinYear,
          memberSource: record.memberSource,
        };
      }
    },
    openChangeOne(status) {
      if (status) {
        this.yearShowOne = true;
      }
    },
    handleClearAcquireYear() {
      //  	console.log("111111");
      this.form.joinYear = ""; // 或者适当的空值，根据你的业务需求
    },
    panelChangeOne(value) {
      //   	      console.log(value,"111111");
      this.form.joinYear = value;
      this.$refs.ruleForm.clearValidate("joinYear");
      this.yearShowOne = false;
    },
    getcylist() {
      getAction("/baseCommon/getDictItemsByCode?code=member_source", {}).then(
        (res) => {
          if (res.code == 200) {
            console.log(res);
            this.cylist = res.result;
          }
        }
      );
    },
    getsjlist() {
      getAction("/baseCommon/getDictItemsByCode?code=yn", {}).then((res) => {
        if (res.code == 200) {
          console.log(res);
          this.sjlist = res.result;
        }
      });
    },
    getzclist() {
      getAction("/baseCommon/getDictItemsByCode?code=professional", {}).then(
        (res) => {
          if (res.code == 200) {
            console.log(res);
            this.zclist = res.result;
          }
        }
      );
    },
    getxwlist() {
      getAction("/baseCommon/getDictItemsByCode?code=degree", {}).then(
        (res) => {
          if (res.code == 200) {
            //              console.log(res);
            this.xwlist = res.result;
          }
        }
      );
    },
    getsexlist() {
      getAction("/baseCommon/getDictItemsByCode?code=sex", {}).then((res) => {
        if (res.code == 200) {
          console.log(res);
          this.sexlist = res.result;
        }
      });
    },
    handleCancel() {
      this.visible = false;
    },
    submit() {
      console.log("11111", this.type);
      if (this.disabled) {
        this.visible = false;
        return false;
      }
      if (
        typeof this.form.joinYear == "object" &&
        this.form.joinYear != "" &&
        this.type == "add"
      ) {
        this.form.joinYear = new Date(this.form.joinYear).getFullYear() + "";
      }
      this.$refs.ruleForm.validate((valid) => {
        console.log(valid);
        if (valid) {
          const dateObj = new Date(this.form.birthday);
          const year = dateObj.getFullYear();
          const month = dateObj.getMonth() + 1; // 月份是从 0 开始的，所以要加 1
          const date = dateObj.getDate();
          const formattedDate = `${year}-${month
            .toString()
            .padStart(2, "0")}-${date.toString().padStart(2, "0")}`;
          if (this.type == "add") {
            let params = this.form;
            //          console.log("12345678");
            params.birthday = formattedDate;
            params.applyType = this.applyType;
            //          console.log("1111111");
            postAction("/lxBase/lxApplyGroup/add", params).then((res) => {
              if (res.code == 200) {
                this.visible = false;
                this.$message.success("添加成功");
                this.$emit("addTeacher");
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            let params = this.form;
            params.applyType = this.applyType;
            if (typeof this.form.joinYear == "object") {
              params.joinYear = new Date(this.form.joinYear).getFullYear() + "";
            }
            params.birthday = formattedDate;
            putAction("/lxBase/lxApplyGroup/edit", params).then((res) => {
              if (res.code == 200) {
                this.visible = false;
                this.$message.success("编辑成功");
                this.$emit("addTeacher");
              } else {
                this.$message.error(res.message);
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .ant-modal-title {
  text-align: center;
}
/deep/ .ant-input-number-handler-wrap {
  display: none;
}
</style>
